import CoreServices from './coreServices'
import { AUTH } from '../constants/services'
import axios from 'axios'
import Cookies from 'js-cookie'

class AuthServices extends CoreServices {
  async login(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/login`, { ...args, device: 'web' })
      let data = await response.data.data
      return data
    } catch (error) {
      console.log(error.response.data.message)
      return { error: error.response.data }
    }
  }

  async getAccessTokenByAuth(auth) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/login-auth-token`, { auth: auth })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async socialGoogle(args) {
    args.ads = Cookies.get('ads')
    args.ref = Cookies.get('ref')
    args.pi = Cookies.get('pi')
    args.domain = Cookies.get('domain')
    if (Cookies.get('gclid')) args.ad_source = 'google'

    try {
      let response = await axios.post(`${this.apiEnpointV1}/login/${args.provider}`, { ...args, device: 'web' })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async guest(args) {
    if (Cookies.get('gclid')) args.ad_source = 'google'

    try {
      let response = await axios.post(`${this.apiEnpointV1}/guest`, args)
      let data = await response.data.data
      return data || { error: { message: 'Unexpected response from server.' } }
    } catch (error) {
      return { error }
    }
  }

  async register(args) {
    args.ads = Cookies.get('ads')
    args.ref = Cookies.get('ref')
    args.pi = Cookies.get('pi')
    args.domain = Cookies.get('domain')
    if (Cookies.get('gclid')) args.ad_source = 'google'

    try {
      if (args.email) {
        args.email = args.email.toLocaleLowerCase()
      }

      let response = await axios.post(`${this.apiEnpointV1}/register`, { ...args, device: 'web' })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async guestRegister(args) {
    args.ads = Cookies.get('ads')
    args.ref = Cookies.get('ref')
    args.pi = Cookies.get('pi')
    args.domain = Cookies.get('domain')
    if (Cookies.get('gclid')) args.ad_source = 'google'

    try {
      if (args.email) {
        args.email = args.email.toLocaleLowerCase()
      }

      let response = await axios.post(`${this.apiEnpointV1}/users/guest-register`, { ...args, device: 'web' }, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async logout() {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/logout`, {}, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async resetPassword(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/reset-password`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async changePassword(args) {
    try {
      let response = await axios.put(`${this.apiEnpointV1}/change-password`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async resendVerifyEmail() {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/resend-verify-email`, {}, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data
      return data
    } catch (error) {
      return { error }
    }
  }
}

export default new AuthServices(AUTH.BASE)
